<template>
  <div class="millikan-oil-drop-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>q = mg / E = mgd / V$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Parallel Plates -->
          <rect x="80" y="40" width="240" height="10" fill="#888" />
          <rect x="80" y="190" width="240" height="10" fill="#888" />
          <text x="330" y="50" fill="#ff4757" font-size="10" v-if="voltage > 0">+</text>
          <text x="330" y="200" fill="#2ed573" font-size="10" v-if="voltage > 0">-</text>

          <!-- Oil Drops -->
          <g v-for="drop in drops" :key="drop.id">
            <circle :cx="drop.x" :cy="drop.y" :r="drop.r" fill="#ffd700" :opacity="0.8">
               <title>电荷 q = {{ drop.q }}e</title>
            </circle>
            <!-- Velocity Vector -->
            <line v-if="voltage > 0" :x1="drop.x" :y1="drop.y" :x2="drop.x" :y2="drop.y + drop.vy*10" stroke="#00d2ff" stroke-width="1" marker-end="url(#v-arrow)" />
          </g>

          <defs>
            <marker id="v-arrow" markerWidth="6" markerHeight="4" refX="0" refY="2" orient="auto">
              <polygon points="0 0, 6 2, 0 4" fill="#00d2ff" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电压 V: {{ voltage }} V</label>
           </div>
           <div class="observation">
              通过调节电压使油滴悬浮（平衡状态）
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>控制板间电压: {{ voltage }} V</label>
             <el-slider v-model="voltage" :min="0" :max="500" size="mini"></el-slider>
          </div>
          <div class="row button-group">
             <el-button type="primary" size="mini" @click="spawnDrops">喷洒油滴</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>密立根通过测量悬浮油滴的平衡电压，发现所带电荷 q 总是某一最小单位的<strong>整数倍</strong>。这一实验首次精确测量了元电荷 $e$ 的值，证明了电荷的<strong>量子化</strong>特性。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MillikanOilDropViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      voltage: 0,
      drops: [],
      timer: null,
      g: 0.1,
      damping: 0.98
    }
  },
  methods: {
    spawnDrops() {
      this.drops = Array.from({ length: 8 }, (_, i) => ({
        id: Date.now() + i,
        x: 100 + Math.random() * 200,
        y: 60 + Math.random() * 40,
        r: 2 + Math.random() * 2,
        q: Math.floor(Math.random() * 5) + 1, // 1 to 5 units of e
        vy: 0
      }));
    },
    update() {
      this.drops.forEach(drop => {
        // Force gravity
        let fg = drop.r * 0.05; 
        // Force electric Fe = qE = q * V/d
        let fe = drop.q * (this.voltage / 1000);
        
        let ay = fg - fe;
        drop.vy = (drop.vy + ay) * this.damping;
        drop.y += drop.vy;

        // Bounce/Limit
        if (drop.y > 185) { drop.y = 185; drop.vy = 0; }
        if (drop.y < 55) { drop.y = 55; drop.vy = 0; }
      });
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() {
    this.spawnDrops();
    this.update();
  },
  beforeDestroy() {
    cancelAnimationFrame(this.timer);
  }
}
</script>

<style scoped lang="scss">
.millikan-oil-drop-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.observation { font-size: 0.65rem; color: #ffd700; margin-top: 5px; font-style: italic; }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
